<template>
  <v-container fluid class="px-0">
    <div class="payroll-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.payrolltype }} {{ initvalue.payrollnum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" align="right">
                    <v-btn
                      class="button-shadow mr-1"
                        @click="Done"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Payroll Name</td>
                        <td>{{ initvalue.payrollname }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Payroll Date</td>
                        <td>{{ new Date(initvalue.payrolldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Start Date</td>
                        <td>{{ new Date(initvalue.payrollstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">End Date</td>
                        <td>{{ new Date(initvalue.payrollenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Status</td>
                        <td>{{ initvalue.payrollstatus }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Total</td>
                        <td>{{ data_total.toFixed(2) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Payments</td>
                        <td>{{ data_payments.toFixed(2) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Balance</td>
                        <td>{{ data_balance.toFixed(2) }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-statements'"
                    >
                      Statements
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-payments'"
                    >
                      Payments
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-statements'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :loading="isReceiving || isDeleting"
                            loading-text="Loading... Please wait"
                            class="paystatements-table"
                            show-select
                            single-select
                            item-key="_id"
                            sort-desc
                            sort-by="paystatementnum"
                            :footer-props="footer"
                            :headers="header_statements"
                            :items="statements"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.employeeid="{ item }">
                              <v-avatar v-if="item.employeeimage!=null" size="40">
                                <img v-bind:src="item.employeeimage" alt="">
                              </v-avatar>
                              <v-avatar
                                v-else
                                color="warning"
                                size="40">
                                <span class="white--text headline">{{ item.employeename[0].toUpperCase() }}</span>
                              </v-avatar>
                              <span style="margin-left:15px">{{ item.employeename }} </span>
                            </template>
                            <template v-slot:item.paystatementnum="{ item }">
                              <p class="two-line">{{ item.paystatementtype  }}</p>
                              <p class="two-line">{{ item.paystatementnum  }}</p>
                            </template>
                            <template v-slot:item.paystatementaddress="{ item }">
                              <p class="two-line">{{ item.paystatementaddress }}</p>
                            </template>
                            <template v-slot:item.paystatementstatus="{ item }">
                              <v-chip
                                :color="item.paystatementstatus=='New' ? 'primaryConst white--text' : item.paystatementstatus=='Pending' ? 'warning white--text' : item.paystatementstatus=='Complete' ? 'successConst white--text' : 'secondaryConst white--text'"
                                small>
                                {{ item.paystatementstatus }}
                              </v-chip>
                            </template>
                            <template v-slot:item.paystatementdate="{ item }">
                              {{ new Date(item.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                            </template>
                            <template v-slot:item.paystatementnetpay="{ item }">
                              {{ item.paystatementnetpay!=null ? item.paystatementnetpay.toLocaleString('en-SG') : '' }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="printItem(item)">
                                <v-icon>mdi-printer</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-payments'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="header_payments"
                            :items="payments"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.transdesc="{ item }">
                              <p v-if="item.transdesc!=null" class="two-line"><strong>{{ item.transdesc }}:</strong></p>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              <p v-if="item.transdate!=null" class="two-line">{{ new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                            </template>
                            <template v-slot:item.transamount="{ item }">
                              <p v-if="item.transamount!=null" class="two-line">{{ item.transamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item :value="'tab-files'" :key="3">
                      <FileView :id="initvalue._id" :route="`payroll`" :files="files" :data="initvalue"/>
                    </v-tab-item>  
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex';
import FileView from "@/pages/File/Components/FileView.vue";

export default {
  name: "Profile",
  components: {
    FileView
  },
  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      files: [],
      payments: [],
      statements: [],
      header_statements: [
        { text: 'Num', value: 'paystatementnum' },
        { text: 'Date', value: 'paystatementdate' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Net Pay', value: 'paystatementnetpay' },
        { text: 'Status', value: 'paystatementstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      header_payments: [
        { text: 'Payment Date', value: 'transdate', width: '12%' },  
        { text: 'Reference Num', value: 'refnum' },  
        { text: '', value: 'transdesc', width: '8%', align: 'right'},
        { text: 'Payment Amount', value: 'transamount', width: '12%', align: 'right'},
      ],
      itemPerPage: 500,
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      selected: [],
    };
  },
  computed: {
    ...mapState('PayStatement', ['isReceiving', 'isDeleting', 'isUpdating']),
    data_total(){
      let result = this.statements.reduce(function (last, json) {return last + json.paystatementnetpay;}, 0);
      return result;
    },
    data_payments(){
      let result = this.payments.reduce(function (last, json) {return last + json.transamount;}, 0);
      return result;
    },
    data_balance(){
      let result = (this.data_total - this.data_payments);
      if(Math.abs(result)<0.001) result = 0;
      return result;
    }
  },
  methods: {
    ...mapActions('Payroll', ["getPayrollRequest"]),
    ...mapActions('PayStatement', ["getPayStatementsByPayroll"]),
    Done(){
      this.$router.push({ name: 'PayrollList' });
    },
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromPayroll = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    printItem(item) {
      item.payload = this.initvalue;
      item.isFromPayroll = true;
      this.$router.push({ name: 'PayStatementPrint', params: item})
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "PayrollList" });
    //this.data_statements = await this.getPayStatementsByPayroll(this.initvalue._id);
    let data_payroll = await this.getPayrollRequest(this.initvalue._id);
    console.log('here', data_payroll);
    this.files = data_payroll.files;
    this.payments = data_payroll.payments;
    this.statements = data_payroll.paystatements;
  },
};
</script>

<style src="./View.scss" lang="scss"/>
